import React from 'react'
import { Routes, Route, Link, useLocation } from 'react-router-dom'
import UsersPage from './Users/page'
import { cn } from '../../lib/utils';
import PronosPage from './Pronos/page';

const Management = () => {
  const location = useLocation();
  const pathname = location.pathname

  return (
    <div className='flex flex-col items-center w-full mx-auto text-white h-[100dvh] bg-tifo justify-between'>
      <i className='h-[88px] min-h-[88px]'></i>
      
      <div className='w-full h-full max-w-5xl mx-4 overflow-auto'>
        <div className='flex flex-col justify-between h-full'>
          <div className='flex items-center gap-2 border-b border-white/20'>
            <Link
              to="/management/users"
            >
              <div className={cn('flex items-center justify-center px-2 text-sm font-medium h-9 border-b-2 border-transparent',
                pathname === '/management/users' && 'text-tifo-light border-tifo-light',
              )}>
                Gebruikers
              </div>
            </Link>

            <Link
              to="/management/pronos"
            >
              <div className={cn('flex items-center justify-center px-2 text-sm font-medium h-9 border-b-2 border-transparent',
                pathname === '/management/pronos' && 'text-tifo-light border-tifo-light',
              )}>
                Pronostieken
              </div>
            </Link>
          </div>

          <div className='h-full overflow-auto'>
            <Routes>
              <Route path="users" element={<UsersPage />}/>
              <Route path="pronos" element={<PronosPage />}/>
            </Routes>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Management